module.exports = __webpack_public_path__ + "img/course69_summary_unit_timelines.3448857d.png";